import { buildScoreboardRows } from '../domain/scoreboardModel.js';

/**
 * buildMatchScoreboard — Application facade over domain rows (SPY-41 / FID-HUD-03).
 * @param {{ entities?: { getChampions?: () => object[] } }|null} matchRuntime
 * @param {string} [sortKey]
 * @returns {object[]}
 */
export function buildMatchScoreboard(matchRuntime, sortKey = 'team') {
  const champs =
    typeof matchRuntime?.entities?.getChampions === 'function'
      ? matchRuntime.entities.getChampions()
      : [];
  return buildScoreboardRows(champs, sortKey);
}
